// audioBus — a tiny shared controller so the floating action rail (and any other
// UI) can drive the single existing <AudioPlayer> without duplicating it. The
// player registers its toggle + reports play/availability; consumers subscribe.

const listeners = new Set();
let toggleFn = null;
let state = { playing: false, available: false, visible: false };

function emit() {
  for (const l of listeners) l(state);
}

export const audioBus = {
  // Called by AudioPlayer on mount with a stable toggle that reads the <audio>.
  registerToggle(fn) { toggleFn = fn; },
  setAvailable(v) { state = { ...state, available: !!v }; emit(); },
  setPlaying(v) { state = { ...state, playing: !!v }; emit(); },
  // Reveal the scrubber (Listen expands it inline rather than it always showing).
  reveal() { if (!state.visible) { state = { ...state, visible: true }; emit(); } },
  hide() { if (state.visible) { state = { ...state, visible: false }; emit(); } },
  // Called by the rail's Listen button.
  toggle() { if (toggleFn) toggleFn(); },
  getState() { return state; },
  subscribe(l) { listeners.add(l); l(state); return () => listeners.delete(l); },
};

export default audioBus;
